import { render, staticRenderFns } from "./ButtonStrong.vue?vue&type=template&id=c14345d6&scoped=true&lang=pug&"
import script from "./ButtonStrong.vue?vue&type=script&lang=ts&"
export * from "./ButtonStrong.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonStrong.vue?vue&type=style&index=0&id=c14345d6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14345d6",
  null
  
)

export default component.exports